import landownerApi from 'api/landownerApi';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// lay ds khach hang
export const thunkGetLandownerList = createAsyncThunk(
  'landowner/thunkGetLandownerList',
  async (params, thunkAPI) => {
    const res = await landownerApi.getLandownerList(params);
    return res;
  }
);

// ---- params ----
const initialState = {
  isGettingData: false,
  landownerList: [],
  total: 0,
};

const landownerSlice = createSlice({
  name: 'landowner',
  initialState,
  reducers: {},
  extraReducers: {
    // lay ds chu dat
    [thunkGetLandownerList.pending]: (state, action) => {
      state.isGettingData = true;
    },
    [thunkGetLandownerList.rejected]: (state, action) => {
      state.isGettingData = false;
    },
    [thunkGetLandownerList.fulfilled]: (state, action) => {
      state.isGettingData = false;
      const { result, landlords, total } = action.payload;
      if (result === 'success') {
        state.landownerList = landlords ?? [];
        state.total = total ?? 0;
      }
    },
  },
});

const { reducer, actions } = landownerSlice;
export const {} = actions;
export default reducer;
